import { makeStyles } from "@mui/styles";

export const useStyle = makeStyles((theme) => ({
  headerGrid: {
    "&.MuiGrid-root": {
      // display: "flex",
      backgroundColor: "white",
      padding: "5px",
      borderRadius: "10px",
      justifyContent: "end",
      alignItems:'center',
      position: "fixed",
      boxShadow:
        "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);",
      [theme.breakpoints.down("900")]: {
      width:'calc(100% - 30px)',
      // left:15,
      justifyContent: "space-between",
      // backgroundColor:"red"
      },
      zIndex:1,
      right:15,
    },
  },
  menuGrid:{
    "&.MuiIconButton-root": {
      float:"left",
      [theme.breakpoints.up("900")]: {
        display:'none'
      }
    }
  },
  headerWidth:{
    "&.MuiGrid-root": {
      [theme.breakpoints.up("900")]: {
        width:"100%",
        minWidth:"100%",
        maxWidth:"100%"
      }
    }
  },
  userName:{
    "&.MuiTypography-root":{
        marginInline:10,
        fontWeight:600,
        fontSize:22,
        color:"#A06EE1",
        [theme.breakpoints.down("600")]:{
          fontSize:18,
        },
        [theme.breakpoints.down("600")]:{
          fontSize:16,
        }
    }
  }
}));
